import type { ChecklistPhase, ChecklistTask, ChecklistTaskStatus } from './ChecklistTask';

export interface PhaseProgress {
  total: number;
  done: number;
  percent: number;
}

export function computeChecklistProgress(
  tasks: ChecklistTask[],
  phase: ChecklistPhase,
): PhaseProgress {
  const phaseTasks = tasks.filter((t) => t.phase === phase);
  const total = phaseTasks.length;
  const done = phaseTasks.filter((t) => t.status === 'done').length;
  return {
    total,
    done,
    percent: total ? Math.round((done * 100) / total) : 0,
  };
}

export function nextChecklistStatus(status: ChecklistTaskStatus): ChecklistTaskStatus {
  if (status === 'todo') return 'in_progress';
  if (status === 'in_progress') return 'done';
  return 'todo';
}

export type ContractAlertLevel = 'none' | 'warn' | 'danger';

export function contractAlertLevel(
  dueDate: Date | null,
  today: Date = new Date(),
  partnerStatus?: string,
): ContractAlertLevel {
  if (!dueDate || partnerStatus === 'terminated') return 'none';
  const ms = dueDate.getTime() - today.setHours(0, 0, 0, 0);
  const days = Math.ceil(ms / 86400000);
  if (days < 0) return 'danger';
  if (days <= 3) return 'danger';
  if (days <= 7) return 'warn';
  return 'none';
}

export function taskDueAlertLevel(
  dueDate: Date | null,
  status: ChecklistTaskStatus,
  today: Date = new Date(),
): 'none' | 'warn' | 'urgent' | 'overdue' {
  if (!dueDate || status === 'done') return 'none';
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);
  const d = new Date(dueDate);
  d.setHours(0, 0, 0, 0);
  const days = Math.ceil((d.getTime() - t.getTime()) / 86400000);
  if (days < 0) return 'overdue';
  if (days < 3) return 'urgent';
  if (days <= 7) return 'warn';
  return 'none';
}

export function isRegistrationOpen(params: {
  registrationDeadline: Date | null;
  maxParticipants: number | null;
  currentCount: number;
  now?: Date;
}): { open: boolean; reason?: 'deadline' | 'full' } {
  const now = params.now ?? new Date();
  if (params.registrationDeadline && now > params.registrationDeadline) {
    return { open: false, reason: 'deadline' };
  }
  if (
    params.maxParticipants != null &&
    params.currentCount >= params.maxParticipants
  ) {
    return { open: false, reason: 'full' };
  }
  return { open: true };
}
